import React from 'react';
import {useTranslation} from 'react-i18next';
import {Route, Routes, useNavigate} from 'react-router-dom';
import {usePath} from 'hooks';
import {PATHS} from 'routes/constants';
import Page from 'components/Page';
import Tabs, {TAB_TYPES} from 'components/common/Tabs';
import {MyEsimPlans} from './MyEsimPlans/MyEsimPlans';
import {EsimHelp} from './EsimHelp/EsimHelp';
import styles from './styles.module.css';
import cn from 'clsx';

const getLastSegment = (path: string) => path.split('/').pop();

function MyEsimsView() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const onBackClick = () => {
    navigate(getFullPath(PATHS.esim.manage), {replace: true});
  };

  const items = React.useMemo(
    () => [
      {
        id: 'my-plans',
        type: TAB_TYPES.link,
        path: getFullPath(PATHS.esim.my),
        label: t('esim.my.my_plans'),
        selected: true,
        end: true,
      },
      {
        id: 'help',
        type: TAB_TYPES.link,
        path: getFullPath(PATHS.esim.help),
        label: t('esim.my.esim_help'),
        selected: false,
      },
    ],
    [getFullPath, t],
  );

  return (
    <Page
      title={t('esim.my.title')}
      navBarTitle={t('esim.my.title')}
      onBackButtonClick={onBackClick}
      isSubHeaderVisible
      className={cn(styles.MyEsimsView)}
      pageWrapperClassName="[--page-header-shadow:none]"
    >
      <Tabs items={items} />
      <Routes>
        <Route index path="*" element={<MyEsimPlans className="w-full max-w-3xl" />} />
        <Route
          path={getLastSegment(PATHS.esim.help)}
          element={<EsimHelp className="w-full max-w-3xl" />}
        />
      </Routes>
    </Page>
  );
}

export {MyEsimsView};
